export default {
    mounted(el, binding) {
      // 设置初始位置和透明度
      el.style.opacity = 0;
      el.style.transform = `translateY(${binding.value?.distance || 100}px)`;
  
      // 延迟触发飞入动画
      setTimeout(() => {
        el.style.transition = `all ${binding.value?.duration || 0.8}s ${binding.value?.timing || 'ease'}`;
        el.style.opacity = 1;
        el.style.transform = 'translateY(0)';
      }, binding.value?.delay || 0);
    },
  };